export const SET_TAB_ACTIVE = 'SET_TAB_ACTIVE';
export const RESET_SURVEYBUILDER = 'RESET_SURVEYBUILDER';

// API
export const LIST_SURVEYS_REQUEST = 'LIST_SURVEYS_REQUEST';
export const LIST_SURVEYS_SUCCESS = 'LIST_SURVEYS_SUCCESS';
export const LIST_SURVEYS_FAILURE = 'LIST_SURVEYS_FAILURE';

export const GET_SURVEY_REQUEST = 'GET_SURVEY_REQUEST';
export const GET_SURVEY_SUCCESS = 'GET_SURVEY_SUCCESS';
export const GET_SURVEY_FAILURE = 'GET_SURVEY_FAILURE';

export const GET_QUESTIONS_REQUEST = 'GET_QUESTIONS_REQUEST';
export const GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';
export const GET_QUESTIONS_FAILURE = 'GET_QUESTIONS_FAILURE';

export const APPEND_QUESTIONS_REQUEST = 'APPEND_QUESTIONS_REQUEST';
export const APPEND_QUESTIONS_SUCCESS = 'APPEND_QUESTIONS_SUCCESS';
export const APPEND_QUESTIONS_FAILURE = 'APPEND_QUESTIONS_FAILURE';

export const SET_QUESTIONS_PAGE = 'SET_QUESTIONS_PAGE';

export const GET_CHOICES_REQUEST = 'GET_CHOICES_REQUEST';
export const GET_CHOICES_SUCCESS = 'GET_CHOICES_SUCCESS';
export const GET_CHOICES_FAILURE = 'GET_CHOICES_FAILURE';

export const APPEND_CHOICES_REQUEST = 'APPEND_CHOICES_REQUEST';
export const APPEND_CHOICES_SUCCESS = 'APPEND_CHOICES_SUCCESS';
export const APPEND_CHOICES_FAILURE = 'APPEND_CHOICES_FAILURE';

export const GET_CHOICE_TEMPLATES_REQUEST = 'GET_CHOICE_TEMPLATES_REQUEST';
export const GET_CHOICE_TEMPLATES_SUCCESS = 'GET_CHOICE_TEMPLATES_SUCCESS';
export const GET_CHOICE_TEMPLATES_FAILURE = 'GET_CHOICE_TEMPLATES_FAILURE';

export const APPEND_CHOICE_TEMPLATES_REQUEST = 'APPEND_CHOICE_TEMPLATES_REQUEST';
export const APPEND_CHOICE_TEMPLATES_SUCCESS = 'APPEND_CHOICE_TEMPLATES_SUCCESS';
export const APPEND_CHOICE_TEMPLATES_FAILURE = 'APPEND_CHOICE_TEMPLATES_FAILURE';

export const GET_QUESTION_CATEGORIES_REQUEST = 'GET_QUESTION_CATEGORIES_REQUEST';
export const GET_QUESTION_CATEGORIES_SUCCESS = 'GET_QUESTION_CATEGORIES_SUCCESS';
export const GET_QUESTION_CATEGORIES_FAILURE = 'GET_QUESTION_CATEGORIES_FAILURE';

export const GET_QUESTION_CATEGORIES_WITH_QUESTIONS_REQUEST =
  'GET_QUESTION_CATEGORIES_WITH_QUESTIONS_REQUEST';
export const GET_QUESTION_CATEGORIES_WITH_QUESTIONS_SUCCESS =
  'GET_QUESTION_CATEGORIES_WITH_QUESTIONS_SUCCESS';
export const GET_QUESTION_CATEGORIES_WITH_QUESTIONS_FAILURE =
  'GET_QUESTION_CATEGORIES_WITH_QUESTIONS_FAILURE';

export const CREATE_QUESTION_CATEGORY_REQUEST = 'CREATE_QUESTION_CATEGORY_REQUEST';
export const CREATE_QUESTION_CATEGORY_SUCCESS = 'CREATE_QUESTION_CATEGORY_SUCCESS';
export const CREATE_QUESTION_CATEGORY_FAILURE = 'CREATE_QUESTION_CATEGORY_FAILURE';

export const GET_CHOICE_CATEGORIES_REQUEST = 'GET_CHOICE_CATEGORIES_REQUEST';
export const GET_CHOICE_CATEGORIES_SUCCESS = 'GET_CHOICE_CATEGORIES_SUCCESS';
export const GET_CHOICE_CATEGORIES_FAILURE = 'GET_CHOICE_CATEGORIES_FAILURE';

export const CREATE_CHOICE_CATEGORY_REQUEST = 'CREATE_CHOICE_CATEGORY_REQUEST';
export const CREATE_CHOICE_CATEGORY_SUCCESS = 'CREATE_CHOICE_CATEGORY_SUCCESS';
export const CREATE_CHOICE_CATEGORY_FAILURE = 'CREATE_CHOICE_CATEGORY_FAILURE';

export const CREATE_SURVEY_REQUEST = 'CREATE_SURVEY_REQUEST';
export const CREATE_SURVEY_SUCCESS = 'CREATE_SURVEY_SUCCESS';
export const CREATE_SURVEY_FAILURE = 'CREATE_SURVEY_FAILURE';

export const UPDATE_SURVEY_REQUEST = 'UPDATE_SURVEY_REQUEST';
export const UPDATE_SURVEY_SUCCESS = 'UPDATE_SURVEY_SUCCESS';
export const UPDATE_SURVEY_FAILURE = 'UPDATE_SURVEY_FAILURE';

export const CREATE_QUESTION_REQUEST = 'CREATE_QUESTION_REQUEST';
export const CREATE_QUESTION_SUCCESS = 'CREATE_QUESTION_SUCCESS';
export const CREATE_QUESTION_FAILURE = 'CREATE_QUESTION_FAILURE';

export const UPDATE_QUESTION_REQUEST = 'UPDATE_QUESTION_REQUEST';
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS';
export const UPDATE_QUESTION_FAILURE = 'UPDATE_QUESTION_FAILURE';

export const CREATE_CHOICE_TEMPLATE_REQUEST = 'CREATE_CHOICE_TEMPLATE_REQUEST';
export const CREATE_CHOICE_TEMPLATE_SUCCESS = 'CREATE_CHOICE_TEMPLATE_SUCCESS';
export const CREATE_CHOICE_TEMPLATE_FAILURE = 'CREATE_CHOICE_TEMPLATE_FAILURE';

export const UPDATE_CHOICE_TEMPLATE_REQUEST = 'UPDATE_CHOICE_TEMPLATE_REQUEST';
export const UPDATE_CHOICE_TEMPLATE_SUCCESS = 'UPDATE_CHOICE_TEMPLATE_SUCCESS';
export const UPDATE_CHOICE_TEMPLATE_FAILURE = 'UPDATE_CHOICE_TEMPLATE_FAILURE';

export const UPDATE_CANVAS_QUESTIONS_REQUEST = 'UPDATE_CANVAS_QUESTIONS_REQUEST';
export const UPDATE_CANVAS_QUESTIONS_SUCCESS = 'UPDATE_CANVAS_QUESTIONS_SUCCESS';
export const UPDATE_CANVAS_QUESTIONS_FAILURE = 'UPDATE_CANVAS_QUESTIONS_FAILURE';

export const GET_HOOKS_REQUEST = 'GET_HOOKS_REQUEST';
export const GET_HOOKS_SUCCESS = 'GET_HOOKS_SUCCESS';
export const GET_HOOKS_FAILURE = 'GET_HOOKS_FAILURE';

export const CREATE_HOOK_REQUEST = 'CREATE_HOOK_REQUEST';
export const CREATE_HOOK_SUCCESS = 'CREATE_HOOK_SUCCESS';
export const CREATE_HOOK_FAILURE = 'CREATE_HOOK_FAILURE';

export const UPDATE_HOOK_REQUEST = 'UPDATE_HOOK_REQUEST';
export const UPDATE_HOOK_SUCCESS = 'UPDATE_HOOK_SUCCESS';
export const UPDATE_HOOK_FAILURE = 'UPDATE_HOOK_FAILURE';

export const APPEND_HOOKS_REQUEST = 'APPEND_HOOKS_REQUEST';
export const APPEND_HOOKS_SUCCESS = 'APPEND_HOOKS_SUCCESS';
export const APPEND_HOOKS_FAILURE = 'APPEND_HOOKS_FAILURE';

export const GET_MATRIX_CHOICES_REQUEST = 'GET_MATRIX_CHOICES_REQUEST';
export const GET_MATRIX_CHOICES_SUCCESS = 'GET_MATRIX_CHOICES_SUCCESS';
export const GET_MATRIX_CHOICES_FAILURE = 'GET_MATRIX_CHOICES_FAILURE';

export const CREATE_MATRIX_CHOICE_REQUEST = 'CREATE_MATRIX_CHOICE_REQUEST';
export const CREATE_MATRIX_CHOICE_SUCCESS = 'CREATE_MATRIX_CHOICE_SUCCESS';
export const CREATE_MATRIX_CHOICE_FAILURE = 'CREATE_MATRIX_CHOICE_FAILURE';

export const UPDATE_MATRIX_CHOICE_REQUEST = 'UPDATE_MATRIX_CHOICE_REQUEST';
export const UPDATE_MATRIX_CHOICE_SUCCESS = 'UPDATE_MATRIX_CHOICE_SUCCESS';
export const UPDATE_MATRIX_CHOICE_FAILURE = 'UPDATE_MATRIX_CHOICE_FAILURE';

export const APPEND_MATRIX_CHOICES_REQUEST = 'APPEND_MATRIX_CHOICES_REQUEST';
export const APPEND_MATRIX_CHOICES_SUCCESS = 'APPEND_MATRIX_CHOICES_SUCCESS';
export const APPEND_MATRIX_CHOICES_FAILURE = 'APPEND_MATRIX_CHOICES_FAILURE';

// DASHBOARD
export const SET_SURVEY_FILTER = 'SET_SURVEY_FILTER';
export const SET_SURVEY_ACTIVE = 'SET_SURVEY_ACTIVE';
export const SET_SURVEY_INACTIVE = 'SET_SURVEY_INACTIVE';
export const SET_SURVEY_FAVORITE = 'SET_SURVEY_FAVORITE';
export const SET_SURVEY_DELETE = 'SET_SURVEY_DELETE';
export const SET_SURVEY_SORT_BY_FAVORITE = 'SET_SURVEY_SORT_BY_FAVORITE';

// CANVAS QUESTION
export const ADD_CANVAS_QUESTION = 'ADD_CANVAS_QUESTION';
export const SELECT_CANVAS_QUESTION_ID = 'SELECT_CANVAS_QUESTION';
export const SET_CANVAS_QUESTIONS = 'SET_CANVAS_QUESTIONS';

// SELECTOR
export const SELECT_SELECTOR_QUESTION_CATEGORY = 'SELECT_SELECTOR_QUESTION_CATEGORY';
export const SELECT_SELECTOR_TEMPLATE_ID = 'SELECT_SELECTOR_TEMPLATE_ID';
export const SELECT_SELECTOR_TEMPLATE_CATEGORY = 'SELECT_SELECTOR_TEMPLATE_CATEGORY';
export const SELECT_SELECTOR_CHOICE_CATEGORY = 'SELECT_SELECTOR_CHOICE_CATEGORY';
export const SET_SELECTOR_QUESTION_TEXT = 'SET_SELECTOR_QUESTION_TEXT';
export const SET_SELECTOR_TEMPLATE_TEXT = 'SET_SELECTOR_TEMPLATE_TEXT';
export const SET_SELECTOR_CHOICE_TEXT = 'SET_SELECTOR_CHOICE_TEXT';
export const SET_SELECTOR_HOOK_TEXT = 'SET_SELECTOR_HOOK_TEXT';
export const SET_SELECTOR_MATRIX_CHOICE_TEXT = 'SET_SELECTOR_MATRIX_CHOICE_TEXT';
export const RESET_SELECTOR_QUESTION_FILTERS = 'RESET_SELECTOR_QUESTION_FILTERS';
export const RESET_SELECTOR_TEMPLATE_FILTERS = 'RESET_SELECTOR_TEMPLATE_FILTERS';
export const RESET_SELECTOR_CHOICE_FILTERS = 'RESET_SELECTOR_CHOICE_FILTERS';
export const RESET_SELECTOR_HOOK_FILTERS = 'RESET_SELECTOR_HOOK_FILTERS';
export const RESET_SELECTOR_MATRIX_CHOICE_FILTERS = 'RESET_SELECTOR_MATRIX_CHOICE_FILTERS';

export const CREATE_QUESTION = 'CREATE_QUESTION';
export const SET_QUESTION_DIALOG_VISIBILITY = 'SET_QUESTION_DIALOG_VISIBILITY';
export const SET_QUESTION_DIALOG_ADD_TO_CANVAS = 'SET_QUESTION_DIALOG_ADD_TO_CANVAS';
export const SET_QUESTION_DIALOG_FORM = 'SET_QUESTION_DIALOG_FORM';
export const RESET_QUESTION_DIALOG_FORM = 'RESET_QUESTION_DIALOG_FORM';

export const SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY =
  'SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_VISIBILITY';
export const SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_QUESTION =
  'SET_QUESTION_CONDITIONAL_LOGIC_DIALOG_QUESTION';

export const SET_HOOK_DIALOG_VISIBILITY = 'SET_HOOK_DIALOG_VISIBILITY';
export const SET_HOOK_DIALOG_FORM = 'SET_HOOK_DIALOG_FORM';
export const RESET_HOOK_DIALOG_FORM = 'RESET_HOOK_DIALOG_FORM';

export const SET_MATRIX_CHOICE_DIALOG_VISIBILITY = 'SET_MATRIX_CHOICE_DIALOG_VISIBILITY';
export const SET_MATRIX_CHOICE_DIALOG_FORM = 'SET_MATRIX_CHOICE_DIALOG_FORM';
export const RESET_MATRIX_CHOICE_DIALOG_FORM = 'RESET_MATRIX_CHOICE_DIALOG_FORM';

export const SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY =
  'SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_VISIBILITY';
export const SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_MATRIX_CHOICE =
  'SET_MATRIX_CONDITIONAL_LOGIC_DIALOG_MATRIX_CHOICE';

export const SET_CHOICE_TEMPLATE_LIST = 'SET_CHOICE_TEMPLATE_LIST';
export const SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY = 'SET_CHOICE_TEMPLATE_DIALOG_VISIBILITY';
export const SET_CHOICE_TEMPLATE_DIALOG_CHOICES = 'SET_CHOICE_TEMPLATE_DIALOG_CHOICES';
export const SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE = 'SET_CHOICE_TEMPLATE_DIALOG_IS_SCALE';
export const SET_CHOICE_TEMPLATE_DIALOG_FORM = 'SET_CHOICE_TEMPLATE_DIALOG_FORM';
export const RESET_CHOICE_TEMPLATE_DIALOG_FORM = 'RESET_CHOICE_TEMPLATE_DIALOG_FORM';

export const CREATE_QUESTION_CATEGORY = 'CREATE_QUESTION_CATEGORY';
export const SET_QUESTION_CATEGORY_LIST = 'SET_QUESTION_CATEGORY_LIST';
export const SET_QUESTION_CATEGORY_DIALOG_VISIBILITY = 'SET_QUESTION_CATEGORY_DIALOG_VISIBILITY';

export const SET_CHOICE_CATEGORY_DIALOG_VISIBILITY = 'SET_CHOICE_CATEGORY_DIALOG_VISIBILITY';



// WEBPACK FOOTER //
// ./src/store/modules/surveybuilder/mutation-types.js